import { gql } from '@apollo/client';

export const SUBMIT_CITATION = gql`
mutation submitCitation($input: SubmitCitationInput!) {
  submitCitation(input: $input) {
    clientMutationId
    errors
    ticketUuid
     ticket {
      id
      currentStatus
    }
  }
}
`

// Example input
// {
//   "input": {
//    "originatorId": "1243"
//    "officerId": "3472",
//     "password": "Password123",
//   }
// }